import { useEffect, useRef, useState } from 'react'
import { FaMoneyBillAlt, FaPercentage } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { useTypeAndDescription } from '../typeAndDescriptionContext'

import { Container } from './style'

export function CouponType () {
    const [realCouponType , setRealCouponType] = useState('0px')
    const [percentageCouponType , setPercentageCouponType] = useState('0px')

    const isOpenModalForms = useSelector(state => state.modalForms.isOpen)

    const {  
        discountType, setDiscountType,
        realCouponTypeValue, setRealCouponTypeValue,
        percentageCouponTypeValue, setPercentageCouponTypeValue
    } = useTypeAndDescription()


    const content = useRef(null)
    const inputRefReal = useRef(null)
    const inputRefPercentage = useRef(null)



    function handleToggleCoupomType(type) {
        setRealCouponType(type === 0 ? `${content.current.scrollHeight}px` : '0px')
        setPercentageCouponType(type === 1 ? `${content.current.scrollHeight}px` : '0px')
    }



    useEffect(() => {
        if(realCouponTypeValue !== 0){
            inputRefReal.current.value = realCouponTypeValue
            handleToggleCoupomType(0)
        }
          
        if(percentageCouponTypeValue !== 0){
            inputRefPercentage.current.value = percentageCouponTypeValue
            handleToggleCoupomType(1)
        }
    }, [realCouponTypeValue, percentageCouponTypeValue])



    useEffect(() =>{
        if(isOpenModalForms === false){
            setRealCouponType('0px')
            setPercentageCouponType('0px')
            inputRefReal.current.value = ''
            inputRefPercentage.current.value = ''
        }
    }, [isOpenModalForms, setRealCouponType, setPercentageCouponType])



    return(
            <Container realCouponType={realCouponType} percentageCouponType={percentageCouponType}>

                <div className="cardOption" 
                    onClick={() => {
                        handleToggleCoupomType(discountType === -1 || discountType === 1 ? 0 : -1)
                        setDiscountType(discountType === -1 || discountType === 1 ? 0 : -1)
                        setPercentageCouponTypeValue(0)
                        inputRefPercentage.current.value = ''
                    }}
                >
                    <FaMoneyBillAlt />
                    <div>
                        <strong>Real</strong>
                        <p>desconto em valores reais</p>
                    </div>
                </div>

                <div ref={content} className="realInputDiscount">
                    <p>Valor do desconto</p>
                    <input 
                        type="number"
                        ref={inputRefReal}
                        onChange={event => setRealCouponTypeValue(event.target.value)}
                        placeholder="R$ 0,00"
                    />
                </div>




                <div className="cardOption" 
                    onClick={() => {
                        handleToggleCoupomType(discountType === -1 || discountType === 0 ? 1 : -1)
                        setDiscountType(discountType === -1 || discountType === 0 ? 1 : -1)
                        setRealCouponTypeValue(0)
                        inputRefReal.current.value = ''
                    }}
                >
                    <FaPercentage />
                    <div>
                        <strong>Porcentagem</strong>
                        <p>desconto em percentual</p>
                    </div>
                </div>

                <div ref={content} className="percentInputDiscount">
                    <p>Porcentagem do desconto</p>
                    <input 
                        type="number"  
                        ref={inputRefPercentage}
                        onChange={event => {
                            if(event.target.value > 100)
                                event.target.value = 100
                            setPercentageCouponTypeValue(event.target.value)
                        }}  
                        placeholder="0%"
                    />
                </div>

            </Container>
    )
}
